import { render, staticRenderFns } from "./FormFavoritos.vue?vue&type=template&id=5546da2f"
import script from "./FormFavoritos.vue?vue&type=script&lang=js"
export * from "./FormFavoritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports